<template>
    <div>
        <v-row dense>
            <v-col cols="12">
                <v-expansion-panels accordion>
                    <v-expansion-panel>
                        <v-expansion-panel-header>Anuncios</v-expansion-panel-header>
                        <v-expansion-panel-content>
                            <v-row dense v-for="item in notificationsPerslist" :key="item.id" class="my-2">
                                <v-card outlined color="light-gray">
                                    <v-card-text>
                                        <v-row dense>
                                            <v-col cols="12">
                                                <v-row dense>
                                                    <v-col cols="10" class="py-0 font-weight-black primary--text">
                                                        <v-icon icon left x-small>
                                                            {{ item.icon_notif }}
                                                        </v-icon>
                                                        {{ item.titulo_notif }}
                                                    </v-col>
                                                    <!-- <v-col cols="2" class="py-0 d-flex justify-end">
                                                    <ButtonComp @click="readNotif(item.id)"
                                                        :tooltipText="item.estado == false ? 'Notificación sin leer' : 'Notificación leída'"
                                                        :iconBut="item.estado == false ? 'far fa-question-circle' : 'far fa-check-circle'"
                                                        :classColor="item.estado == false ? 'grey' : 'success'" />
                                                </v-col> -->
                                                    <v-col cols="12" class="py-0 d-flex caption font-weight-medium">
                                                        {{ item.contenido_notif }}
                                                    </v-col>

                                                    <v-col cols="12" class="d-flex caption black--text py-0">
                                                        Remitente : {{ item.nombre_persona + ' ' + item.ape1_persona }}
                                                    </v-col>
                                                    <v-col cols="12" class="d-flex gap-10px">
                                                        <v-chip label x-small>
                                                            {{ item.fecha_notif | filtroFecha }}
                                                        </v-chip>
                                                        <v-chip label x-small>
                                                            {{ item.hora_notif | filtroFormatoHora }}
                                                        </v-chip>
                                                    </v-col>
                                                </v-row>
                                            </v-col>
                                        </v-row>
                                    </v-card-text>
                                </v-card>
                            </v-row>
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                    <!-- <v-expansion-panel>
                        <v-expansion-panel-header>Mensajeria</v-expansion-panel-header>
                        <v-expansion-panel-content>

                        </v-expansion-panel-content>
                    </v-expansion-panel> -->
                </v-expansion-panels>

            </v-col>

        </v-row>
    </div>
</template>
<script>
import axios from "@/helpers/axios"
import { mapMutations, mapGetters, mapActions } from 'vuex';
// import ButtonComp from "../components/ComponentsEst/TableButtonComp.vue";
export default {

    components: {
        // ButtonComp
    },
    data: () => ({
        datoLogin: sessionStorage,
        notificationsPerslist: [],
    }),
    mounted() {
        this.loadMain()
    },
    computed: {
        ...mapGetters('login', ['componenteEvento']),
    },

    methods: {
        ...mapMutations('mensajeSis', ['setEnviarMens']),
        ...mapActions('login', ['parametroComponente']),

        async loadMain() {
            this.getnotifications();
        },

        async getnotifications() {
            try {
                let response = await axios.get(`/notification/persona/getglobal/${this.datoLogin.id_colegio}`);
                this.notificationsPerslist = response.data;

            } catch (error) {
                console.log(error);
                this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
            }
        },

        truncateText(text, maxLength) {
            if (text.length > maxLength) {
                return text.substring(0, maxLength) + '...';
            } else {
                return text;
            }
        },

        async readNotif(id) {
            try {
                let response = await axios.post(`/notification/persona/readNotif/${id}`);
                this.setEnviarMens({ tipo: `${response.data.messageT}`, mensaje: `${response.data.message}`, tiempo: null });
            } catch (error) {
                console.log(error);
                this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
            }
        }

    }
}
</script>